import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { subscribeToPush } from "@/lib/push";

// Tente d'abonner l'utilisateur connecté aux notifications push (si déjà autorisé).
export function PushManager() {
  const { user } = useAuth();
  useEffect(() => {
    if (user) subscribeToPush(false);
  }, [user?.id]);
  return null;
}
